import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';
import { SearchType } from '../KiiTypeahead';

export const fetchCoauthorOrTitleSuggestions = (
  queryTerm: string,
  searchType: SearchType,
  displayName: string,
) => {
  const route = routes.api_v0_knowledge_graph_kii_typeahead_path({
    subdomain_param: 'api',
    query_term: encodeURIComponent(queryTerm),
    search_type: searchType,
    display_name: encodeURIComponent(displayName),
  });

  return fetchWithCsrf(route, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
};
